import React, { useEffect } from "react";
import { useAuthState } from "../../context/UserAuthentication";
import { useAppSelector } from "../../redux/store/store";
import { getUser } from "../../helpers/helperMethods";
import { useDispatch } from "react-redux";
import { isLoginAction, isLogoutAction } from "../../redux/slices/cartSlice";

function LogOutAction() {
  const { dispatch, authInfo } = useAuthState();
  const cartDispatch = useDispatch();
  const isLogout = useAppSelector((state) => state.cart.isLogoutAction);
  const isLogin = useAppSelector((state) => state.cart.isLoginAction);

  useEffect(() => {
    if (isLogout) {
      dispatch({ type: "LOGOUT" });
      cartDispatch(isLogoutAction());
    }
  }, [isLogout]);
  
  useEffect(() => {
    let user = getUser();
    if (user.token && isLogin) {
      dispatch({ type: "LOGIN_SUCCESS", payload: user });
      cartDispatch(isLoginAction());
    }
  }, [isLogin]);

  return <></>;
}
export default LogOutAction;
